import api from './axiosInstance';

export const getAll = (params) => api.get('/audit-logs', { params });
export const getEntities = () => api.get('/audit-logs/entities');
